import pt from './pt/pt_PT.json';
import en from './en/en_EN.json';
export default {
  pt: pt,
  en: en
};